class yMenu extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    (this.state = "closed"),
      (this.back_links = this.querySelectorAll(".y-menu--back-link a")),
      (this.regular_links = this.querySelectorAll(
        '.y-menu--level-1--link > a:not([data-submenu="true"]), .y-menu--level-2--link > a:not([data-submenu="true"]), .y-menu--level-3--link > a:not([data-submenu="true"])'
      )),
      (this.timer = null),
      (this.sub_menu_links = []),
      this.querySelectorAll(".icon--chevron-right--small").forEach((e) =>
        this.sub_menu_links.push(e.parentNode)
      ),
      this.listeners();
  }
  disconnectedCallback() {
    [...this.regular_links, ...this.sub_menu_links, ...this.back_links].off(
      "click"
    );
  }
  listeners() {
    this.regular_links.on("click", (e) => {
      const t = e.target.getAttribute("href");
      -1 !== t.indexOf("#") &&
        ("left--opened" === theme.off_canvas.state
          ? theme.off_canvas.closeLeft()
          : "right--opened" === theme.off_canvas.state &&
            theme.off_canvas.closeRight(),
        setTimeout(() => (window.location.href = t), 450));
    }),
      this.sub_menu_links.on("click", (e) => {
        this.openSubMenu(e.target), e.preventDefault(), e.stopPropagation();
      }),
      this.back_links.on("click", (e) => {
        this.closeSubMenu(e.target), e.preventDefault(), e.stopPropagation();
      });
  }
  adjustHeight(e) {
    let t = e.offsetHeight;
    var s = this.offsetHeight,
      l = ((this.style.height = s + "px"), window.getComputedStyle(e).position);
    "absolute" === l &&
      ((e.style.position = "relative"),
      (t = e.offsetHeight),
      (e.style.position = "absolute")),
      (this.style.height = t + "px");
  }
  openSubMenu(e) {
    var t = e.closest("li").querySelector("ul");
    (t.style.display = "block"),
      this.adjustHeight(t),
      (t.style.transform = "translateX(-100%)");
  }
  closeSubMenu(e) {
    var t = e.closest("ul"),
      s = t.parentNode.closest("ul");
    this.adjustHeight(s), (t.style.transform = "translateX(0)");
  }
}
customElements.define("y-menu-root", yMenu);
